import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,_vm._b({attrs:{"value":_vm.value,"items":_vm.taxes,"label":_vm.label,"required":_vm.required},on:{"change":_vm.onInput},scopedSlots:_vm._u([{key:"selection",fn:function({ item }){return [_vm._v(" "+_vm._s(item.state)+" "+_vm._s(item.rate)+"% ")]}},{key:"item",fn:function({ item }){return [_vm._v(" "+_vm._s(item.state)+" "+_vm._s(item.rate)+"% ")]}}])},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }